import { createAction, props } from "@ngrx/store";

export const previousRoute = createAction('[Router] Previous Route', props<{
    customRoute?: string
}>());

export const closeSecondaryMenu = createAction('[Router] Close Secondary');